import React, {useState, useContext, useEffect} from 'react'
import {Row, Col, Form, Button, Alert, Card, Spinner} from 'react-bootstrap';
import moment from 'moment';
import { FiCalendar, FiSearch, FiArrowRight, FiArrowLeft, FiClock } from 'react-icons/fi';
import { FaCalendarAlt } from 'react-icons/fa';
import '../styles/Calendar.css';

import {AppContext} from '../AppContext';
import {tre} from '../trebus'
import SelectUser from './../components/SelectUser'
import PopupTraveller from './../popups/PopupTraveller'

export default function Calendar() {

    const context = useContext(AppContext);

    /* Calendar struct
        [
            {
                days: [
                    {cap:'L'},
                    {cap:'M'},
                    ...
                ]
            },
            {
                days: [
                    {cap:""},
                    {cap:"1", date:"2020-02-01"},
                    {cap:"2", date:"2020-02-02"},
                    ...
                ]
            }
        ]
    */
    const [calendar, setCalendar] = useState();

    const [year, setYear] = useState(parseInt(moment().format('YYYY')));
    const [month, setMonth] = useState(parseInt(moment().format('M')));
    const [showSelectUser, setShowSelectUser] = useState(false);
    const [user, setUser] = useState({name: 'Seleccionar usuario'});
    const [travellers, setTravellers] = useState();
    const [selectedCell, setSelectedCell] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [loadingPaymentStatus, setLoadingPaymentStatus] = useState(false);

    // Years and months
    let years = [0, 1, 2, 3, 4, 5].map(inc => moment().subtract(-2 + inc, 'years').format('YYYY'))
    let months = [
        {id: 1, label: "Enero"},
        {id: 2, label: "Febrero"},
        {id: 3, label: "Marzo"},
        {id: 4, label: "Abril"},
        {id: 5, label: "Mayo"},
        {id: 6, label: "Junio"},
        {id: 7, label: "Julio"},
        {id: 8, label: "Agosto"},
        {id: 9, label: "Septiembre"},
        {id: 10, label: "Octubre"},
        {id: 11, label: "Noviembre"},
        {id: 12, label: "Diciembre"},
    ]

    /**
     * Fill calendar with travellers
     */
    const fillCalendarWithTravellers = (cal) => {

        let trav, date;
        for (const i in cal) {
            for (const j in cal[i].days) {

                date = cal[i].days[j].date;

                for (const n in travellers) {

                    trav = travellers[n];

                    if (trav && date) {

                        // Same date
                        if (moment(trav.trip.date).format('YYYY-MM-DD') === date) {

                            // Go
                            if (trav.trip.route.direction === 'GO')
                                cal[i].days[j].travGo = trav;

                            // Come
                            if (trav.trip.route.direction === 'COME')
                                cal[i].days[j].travCome = trav;
                        }
                    }
                }
            }
        }
    }

    /**
     * Crear datos del calendario
     */
    const createCalendar = () => {

        let momentDate = moment(year + '-' + month + '-01', 'YYYY-MM-DD');
        const numDaysOfMonth = parseInt(momentDate.endOf('month').format('D'));
        const firstDayMonth = momentDate.startOf('month').format('E');
        console.log('Number of days in the month: ' + numDaysOfMonth)

        // Init calendar
        let cal = [
            {
                days: [
                    {cap: 'L'},
                    {cap: 'M'},
                    {cap: 'X'},
                    {cap: 'J'},
                    {cap: 'V'},
                    {cap: 'S'},
                    {cap: 'D'}
                ]
            }
        ];

        for (let i = 1; i < 10; i++) {
            cal.splice(1, 1);
        }

        // Add cells
        let week = {days: []};
        let currentCell = 1;
        while (currentCell < 50) {

            let currentDay = currentCell - firstDayMonth + 1;

            // Day in the month
            if (currentDay > 0 && (currentDay <= numDaysOfMonth)) {

                week.days.push({cap: momentDate.format('D'), date: momentDate.format('YYYY-MM-DD')});
                momentDate.add('days', 1);

                // Day out of the month, just let it in blank
            } else {
                week.days.push({cap: ''});
            }

            // Next week
            if (week.days.length === 7) {
                cal.push(week);
                week = {days: []};
            }

            // Next cell
            currentCell++;
        }

        // Fill calendar with travellers
        if (travellers) {
            fillCalendarWithTravellers(cal)
        }

        setCalendar(cal)
    }

    /**
     * Open cell
     *
     *    * string date: format Y-m-d
     */
    const openCell = (cell) => {

        if (cell.date) {
            setSelectedCell(cell)
        }
    }

    /**
     * Obtener viajeros (los viajes) del usuario
     */
    const loadTravellersOfUser = () => {
        tre.api('GET', '/users/' + user.id + '/travellers', {
            context: context,
            success: (r) => {
                setTravellers(r);
            }
        });
    }

    /**
     * Check payment status for current month/year
     */
    const checkPaymentStatus = () => {
        if (!user || !user.id) return;
        
        setLoadingPaymentStatus(true);
        
        // Format month and year for API request
        const monthParam = month.toString().padStart(2, '0'); // Ensure two digits
        const yearParam = year.toString();
        
        // Call API with month and year parameters
        tre.api('GET', `/users/${user.id}/payments`, {
            context: context,
            params: {
                month: monthParam,
                year: yearParam
            },
            success: (response) => {
                console.log('Payment status response:', response);
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                    // Check specifically the first payment (index 0) for is_paid status
                    const firstPayment = response.data[0];
                    // Check if is_paid equals 1 (numeric value)
                    const isPaid = firstPayment && firstPayment.is_paid === 1;
                    
                    console.log('First payment is_paid value:', firstPayment ? firstPayment.is_paid : 'no payment');
                    console.log('Payment considered paid:', isPaid);
                    console.log('First payment details:', firstPayment);
                    
                    setPaymentStatus({
                        isPaid,
                        payments: response.data
                    });
                } else {
                    // No payments found for this month/year
                    console.log('No payments found for', monthParam, yearParam);
                    setPaymentStatus({
                        isPaid: false,
                        payments: []
                    });
                }
                setLoadingPaymentStatus(false);
            },
            error: (err) => {
                console.error('Error fetching payment status:', err);
                setPaymentStatus(null);
                setLoadingPaymentStatus(false);
            }
        });
    };

    /**
     * Year, month, travellers changes
     */
    useEffect(() => {
        if (year) createCalendar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, month, travellers])
    
    /**
     * Check payment status when user, month or year changes
     */
    useEffect(() => {
        if (user && user.id && context.user && context.user.role === 'USER') {
            checkPaymentStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, month, year]);

    /**
     * Select user
     */
    const onSelectUser = (user) => {

        setUser(user)
        setShowSelectUser(false)
    }

    /**
     * User changes
     */
    useEffect(() => {

        if (user && user.id) loadTravellersOfUser()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    /**
     * Init
     */
    useEffect(() => {

        tre.api('GET', '/me', {
            context: context,
            success: (r) => {

                if (r.role === 'USER') onSelectUser(r)
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Render
    return (
        <div className="container py-4">
            {/* Header */}
            <div className="mb-4">
                <h4 className="mb-1" style={{ color: '#202124', fontWeight: 500 }}>
                    <FiCalendar className="me-2" style={{ color: '#1a73e8' }} />
                    Calendario de Viajes
                </h4>
                <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                    Consulta y gestiona tus viajes programados
                </p>
            </div>

            <Card style={{ border: 'none', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
                <Card.Body className="p-4">
                    {user?.company?.msg_for_user &&
                        <Alert
                            variant="info"
                            className="mb-4"
                            style={{
                                backgroundColor: '#e8f0fe',
                                border: '1px solid #c2d9fc',
                                borderRadius: '8px',
                                color: '#1a73e8'
                            }}
                        >
                            {user.company.msg_for_user}
                        </Alert>
                    }

                    {context.user && context.user.role === 'USER' && (
                        loadingPaymentStatus ? (
                            <Alert
                                variant="light"
                                className="mb-4 d-flex align-items-center"
                                style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}
                            >
                                <Spinner animation="border" size="sm" className="me-2" style={{ color: '#1a73e8' }} />
                                <span>Comprobando estado de pago para {months.find(m => m.id === month)?.label} {year}...</span>
                            </Alert>
                        ) : paymentStatus ? (
                            <Alert
                                className="mb-4"
                                style={{
                                    backgroundColor: paymentStatus.isPaid ? '#e6f4ea' : '#fef7e0',
                                    border: `1px solid ${paymentStatus.isPaid ? '#c6e6cf' : '#fce8b2'}`,
                                    borderRadius: '8px',
                                    color: paymentStatus.isPaid ? '#34a853' : '#f9ab00'
                                }}
                            >
                                <strong>{months.find(m => m.id === month)?.label} {year}: </strong>
                                {paymentStatus.isPaid ? (
                                    "La mensualidad está pagada correctamente."
                                ) : (
                                    "La mensualidad está pendiente de pago."
                                )}
                                {paymentStatus.payments && paymentStatus.payments.length > 0 && (
                                    <div className="mt-2 small">
                                        {paymentStatus.payments.length === 1 ?
                                            "Se encontró 1 pago para este mes." :
                                            `Se encontraron ${paymentStatus.payments.length} pagos para este mes.`
                                        }
                                    </div>
                                )}
                            </Alert>
                        ) : null
                    )}

                    {/* Filters */}
                    <div className="d-flex flex-wrap align-items-end gap-3 mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                        <Form.Group style={{ minWidth: '100px' }}>
                            <Form.Label className="text-muted" style={{ fontSize: '13px', marginBottom: '4px' }}>Año</Form.Label>
                            <Form.Select
                                value={year}
                                onChange={e => setYear(parseInt(e.target.value))}
                            >
                                {years && years.map(year =>
                                    <option key={year} value={year}>{year}</option>
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group style={{ minWidth: '140px' }}>
                            <Form.Label className="text-muted" style={{ fontSize: '13px', marginBottom: '4px' }}>Mes</Form.Label>
                            <Form.Select
                                value={month}
                                onChange={e => setMonth(parseInt(e.target.value))}
                            >
                                {months && months.map(month =>
                                    <option key={month.id} value={month.id}>{month.label}</option>
                                )}
                            </Form.Select>
                        </Form.Group>

                        {context.user.role !== 'USER' &&
                            <>
                                <Form.Group style={{ flex: 1, minWidth: '200px' }}>
                                    <Form.Label className="text-muted" style={{ fontSize: '13px', marginBottom: '4px' }}>Usuario</Form.Label>
                                    <Form.Control
                                        disabled
                                        value={user.name}
                                        style={{ backgroundColor: 'white' }}
                                    />
                                </Form.Group>

                                <Button
                                    variant="outline-primary"
                                    onClick={() => setShowSelectUser(true)}
                                >
                                    <FiSearch className="me-2" />
                                    Buscar
                                </Button>
                            </>}
                    </div>

                    <div className="calendar-grid">
                        {calendar && calendar.map((week, numWeek) =>
                            <div key={numWeek} className="d-flex">
                                {week && week.days && week.days.map((cell, idx) =>
                                    <div
                                        key={idx}
                                        className={`calendar-cell ${numWeek === 0 ? 'header' : ''} ${cell.cap ? 'has-content' : ''}`}
                                        style={{
                                            height: numWeek > 0 ? '150px' : '36px'
                                        }}
                                        onClick={() => openCell(cell)}
                                    >
                                        <div className="cell-date">
                                            {cell.cap}
                                        </div>
                                        {numWeek > 0 && <CalendarCell cell={cell}/>}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <SelectUser
                show={showSelectUser}
                toggle={() => setShowSelectUser(!showSelectUser)}
                onSelect={onSelectUser}
            />

            <PopupTraveller
                open={selectedCell !== null}
                date={selectedCell && selectedCell.date}
                idTravellerGo={selectedCell && selectedCell.travGo && selectedCell.travGo.id}
                idTravellerCome={selectedCell && selectedCell.travCome && selectedCell.travCome.id}
                idUser={user && user.id}
                onClose={() => setSelectedCell(null)}
                onUpdateUser={user => setUser(user)}
                onUpdateTraveller={() => loadTravellersOfUser()}
            />

        </div>
    )
}

/**
 * Calendar cell
 */
function CalendarCell({cell}) {
    return (
        <div className="calendar-cell-content">
            {cell && cell.travGo &&
                <div className="trip-info go">
                    <div className="trip-label go">
                        <FiArrowRight size={10} />
                        IDA
                    </div>
                    <div className="location">
                        {cell.travGo.start && cell.travGo.start.name}
                    </div>
                    <div className="time">
                        <FiClock size={10} />
                        {cell.travGo.trip && moment(cell.travGo.trip.route.departure, 'HH:mm:00').format('HH:mm')}
                    </div>
                </div>
            }

            {cell && cell.travCome &&
                <div className="trip-info come">
                    <div className="trip-label come">
                        <FiArrowLeft size={10} />
                        VUELTA
                    </div>
                    <div className="location">
                        {cell.travCome.start && cell.travCome.start.name}
                    </div>
                    <div className="time">
                        <FiClock size={10} />
                        {cell.travCome.trip && moment(cell.travCome.trip.route.departure, 'HH:mm:00').format('HH:mm')}
                    </div>
                </div>
            }
        </div>
    )
}
